<template>
  <div class="notFound">
    <h1>Not Found</h1>
    <div v-if="env !== 'production' && env !== 'development'">
      <p>こちらからログインしてください ※この文言は開発環境にのみ表示されています</p>
      <a :href="loginUrl">{{ loginUrl }}</a>
    </div>
  </div>
</template>

<script>
export default {
  head: {
    meta: [
      { hid: 'noindex', name: 'robots', content: 'noindex' },
    ],
  },
  data () {
    return {
      env: process.env.VUE_APP_ENV,
      loginUrl: process.env.VUE_APP_VUE_HOST + '/a1.clxdev.mpse.jp/wc99101/login',
    }
  },
}
</script>
